const plugin = {
  install(vue) {
    vue.mixin({
      computed: {
        $name() {
          return this.$store.getters.uc ? this.$store.getters.uc.name : ''
        },
        $isSupper() {
          return this.$store.getters.isSuper
        },
      },
    })
  },
}

export default plugin
export const { install } = plugin
